.adminUsersPageContainer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
}

.leftColumnContainer {
  min-width: 410px;
  max-width: 25%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-right: 1px solid var(--static-divider-standard);
}

.userSearchContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.75rem;
  border-bottom: 1px solid var(--static-divider-standard);
}

.search {
  width: 100%;
  margin-bottom: 0px !important;
}

.usersListContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--color-primary) var(--static-background-strong);
}

.userItemContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1rem 1.75rem;
  border-bottom: 1px solid var(--static-divider-standard);
  cursor: pointer;
  transition: 0.2s;
}
.userItemContainer:hover {
  background-color: var(--static-background-strong);
  transition: 0.2s;
}
.userItemContainerActive {
  background-color: var(--static-background-strong);
}

.userItemName {
  font-size: 18px;
  font-weight: 800;
  color: var(--static-text-standard);
}

.userItemEmail {
  font-size: 14px;
  color: var(--static-text-weak);
}

.noResultsStateContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 1.75rem;
}

.noResultsText {
  font-size: 18px;
  font-weight: 800;
  color: var(--static-text-standard);
}

.paginationControlsContainer {
  width: 100%;
  border-top: 1px solid var(--static-divider-standard);
  padding: 1rem 1.75rem;
}

.userBannerContainer {
  background-color: var(--color-primary);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.1rem 1.75rem;
}

.userBannerName {
  color: var(--static-text-strong);
  font-size: 14px;
}

.closeButton {
  color: var(--static-text-standard);
}
.closeButton:hover {
  background-color: var(--primary-hover) !important;
}

.rightColumnContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.rightColumnInnerContainer {
  width: 100%;
  height: 100%;
  background-color: var(--static-background-strong);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 1.75rem;
}

.focusedUserContainer {
  background-color: var(--static-background-standard);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  border: 1px solid var(--static-divider-standard);
  padding: 2rem;
  width: 100%;
}

.zeroStateText {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--static-text-strong);
  font-size: 18px;
  height: 100%;
}

.focusedUserName {
  color: var(--static-text-strong);
  font-size: 32px;
}

.focusedUserEmail {
  color: var(--static-text-standard);
  font-size: 14px;
}

.mirrorButton {
  width: 130px !important;
}